import {BaseStore, globalStore} from "../../stem-core/state/Store";

@globalStore
export class CurrencySettings extends BaseStore("CurrencySettings") {}
